fx.ns("desktop.common.panels", class StickersPanel extends fx.components.VBox
{  
	constructor(model, options)
	{
		super();

		this.model = model;
		this.data = model.stickers;
		this._shapes = model.shapes;
		this._creation = model.creation;

        this._options = Object.assign(this.defaults, options || {});

		this._onSearchUpdatedHandler = this._onSearchUpdated.bind(this);

	}


    get defaults()
    {
        return { 
                    shapes : true,
                    search : true,
                };
    }

    get options()
	{
		return this._options;
	}

	get data()
	{
		return super.data;
	}

	set data(val)
	{
		if (val instanceof fx.ModelArray)
			super.data = val;
		else
		if (val)
		{
			this.model = val;
			this.data = val.stickers;
			this._shapes = val.shapes;
			this._creation = val.creation;
		}

		if (this.grid && val)
			this.grid.data = val;
	}

	get creation()
	{
		return this._creation;
	}

	set creation(val)
	{
		this._creation = val;
	}

	set renderers(val)
	{
		if (this.grid)
			this.grid.renderers = val;
	}


	get visible()
	{
		return super.visible;
	}

	set visible(val)
	{
		super.visible = val;

		if (val && this._toRefresh && this.grid)
		{
			this.grid.refresh();
			this._toRefresh = false;
		}
	}
 
	onReady()
	{
		super.onReady();

		this.on("updated", this.onSearchUpdated, this.search);
		this.on("selected", this.onSelected, this.search);
		this.on("enter", this.onSelected, this.search);


		this.on("more", this.onMore, this.grid);

		this.on("loaded", this._onLoaded, this.data);

        // TODO : check this out
		//this.data.bookid = this.creation.id;
		//this.data.themeid = this.creation.themeid;
	}



	create()
	{
		super.create();

        this.stickerFilter = new filters.StickerFilter(this.creation);

        if (this.options.shapes)
		    this.shapes = new shared.panels.Shapes( this._shapes, {itemWidth : 45, itemHeight : 50} );

        if (this.options.search)
		    this.search = new fx.components.SearchInput({placeHolder : fx.text("Rechercher"), propositions : this.data.categories});

        
		this.grid = new fx.components.VerticalGridDynamic( {	data : this.data, 
																elementWidth : 200, 
																elementHeight : 200, 
																filter : this.stickerFilter, 
																tilesSameSize : true,
																renderers : {Sticker : shared.renderers.StickerRenderer}} );
		
        if (this.shapes)
		    this.addChild(this.shapes, {width:"100%", height : 100});

        if (this.search)
		    this.addChild(this.search, {width:"100%", top : 5});

		this.addChild(this.grid, {height:"fill", width:"100%", top : this.creation.useMedias ? 20 : 0});

	}

	onSearchUpdated(e)
	{
		this.delay(this._onSearchUpdatedDelayed, 250);
	}

	_onSearchUpdatedDelayed()
	{
        if (!this.search) return;

		this.stickerFilter.search = "";

		if (this.search.value != "")
		{
			this.search.waiting = true;
			this.data.searchTags( this.search.value, this._onSearchUpdatedHandler );
		}
		else
		{
			this.data.search(false);
			this._showShapes( true );
		}
			
	}

	_onSearchUpdated(results)
	{
        if (!this.search) return;
            
		this.search.waiting = false;
		this.search.results = results;
	}

	onSelected(e)
	{
		this.grid.loading(true);
		this.grid.scrollTop();
		
        if (!this.search) return;

		this.stickerFilter.search = this.search.value;

		this._showShapes( this.search.value == "" );
		this.data.search(this.search.value);
	}

	_onLoaded()
	{
		this.grid.loading(false);
	}

	_showShapes(value)
	{
        if (!this.shapes) return;

		if (value)
			this.shapes.height(100, true);
		else
			this.shapes.height(0, true);
	}

	onMore()
	{
		this.data.loadMore(this.creation);
	}

});